import * as React from "react";
import type { SVGProps } from "react";
const SvgPercentage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m19.707 5.707-14 14a1 1 0 0 1-1.414-1.414l14-14a1 1 0 1 1 1.414 1.414"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 13a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPercentage;
